export default "__VITE_ASSET__b1965ea2__"